import React from 'react'
import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <div className='relative flex flex-col min-h-screen bg-gray-100'>
        <Outlet />
    </div>
  )
}

export default Layout